import {
  darkThemeOptions as sharedDarkTheme,
  lightThemeOptions as sharedLightTheme,
  ThemeNames,
} from '@modernloop/shared/theme';
import { createTheme as createMuiTheme } from '@mui/material';
import _ from 'lodash';

import { ColorScheme } from 'src/theme/ColorSchemePreference';

import darkTheme from './dark';
import lightTheme from './light';
import { Theme, ThemeOptions } from './type';

const baseOptions: ThemeOptions = {
  direction: 'ltr',
};

const createMergedTheme = (colorScheme: ColorScheme = ThemeNames.LIGHT): Theme => {
  const isDarkMode = colorScheme === ThemeNames.DARK;
  const appTheme = isDarkMode ? darkTheme : lightTheme;
  const sharedTheme = isDarkMode ? sharedDarkTheme : sharedLightTheme;
  const theme = createMuiTheme(_.merge({}, baseOptions, appTheme, sharedTheme));
  return theme;
};

export default createMergedTheme;
